var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75V22.75C8.25 23.6783 8.61875 24.5685 9.27513 25.2249C9.9315 25.8813 10.8217 26.25 11.75 26.25H18.75M4.75 1.75H11.75C13.683 1.75 15.25 3.317 15.25 5.25V12.25C15.25 14.183 13.683 15.75 11.75 15.75H4.75C2.817 15.75 1.25 14.183 1.25 12.25V5.25C1.25 3.317 2.817 1.75 4.75 1.75ZM22.25 19.25H29.25C31.183 19.25 32.75 20.817 32.75 22.75V29.75C32.75 31.683 31.183 33.25 29.25 33.25H22.25C20.317 33.25 18.75 31.683 18.75 29.75V22.75C18.75 20.817 20.317 19.25 22.25 19.25Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperation);
export default __webpack_public_path__ + "static/media/cooperation.86e0d09479a165830241a6074e1fa9f8.svg";
export { ForwardRef as ReactComponent };